<template>
  <div>
    <v-card class="mx-auto pt-2">
      <v-card-text>
        <div>
          แผนที่
          <b style="font-size:150%">{{obj.sort}}</b>
          {{obj.planDesc}}
        </div>
        <div>
          <strong>กำหนดเสร็จ :</strong>
          {{ convDate2(obj.planDueDate, 'DD/MM/YYYY') }}
        </div>
        <div>
          <strong>ค่าน้ำหนัก :</strong>
          {{ obj.planWeight }}
        </div>
        <div>
          <strong>ผู้รับผิดชอบ :</strong>
          {{ profileLookup[obj.planResponsiblePeople] && profileLookup[obj.planResponsiblePeople].FULLNAME }}
        </div>
        <div>
          <v-slider
            readonly
            v-model="obj.planProgress"
            min="0"
            max="100"
            :label="`ความคืบหน้า (${obj.planProgress || 0})`"
            thumb-label
          ></v-slider>
        </div>
        <div>
          <v-textarea
            readonly
            dense
            label="รายละเอียดความคืบหน้า"
            outlined
            v-model="obj.planProgressDetail"
          ></v-textarea>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    obj: {
      type: Object,
      default: {},
    },
    profileLookup: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      offset: 0,
    };
  },
};
</script>

<style>
</style>